import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setMessage(data.message);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <header className="forgot-password-header">
        <button onClick={() => navigate(`/`)}>Back to Login</button>
      </header>
      <br></br>
      <h1>Forgot Password</h1>
      <br></br>
      <div className="forgot-password-body">
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div>
            <button type="submit" disabled={loading}>
              {loading ? "Loading..." : "Send Reset Link"}
            </button>
          </div>
        </form>

        {message && <div className="success-popup">{message}</div>}
        {error && <div className="error-popup">{error}</div>}
      </div>
    </div>
  );
}

export default ForgotPassword;
